import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Procced from "../../Components/TopUp/Procced";

import TopUPOption from "../../Components/TopUp/TopUpOption";
import Spinner from "../../Components/UI/Spinner/Spinner";
import * as actionCreator from "../../Store/actions/index";

class TopUp extends Component {
  render() {
    return (
      <Fragment>
        {this.props.toping ? (
          <div style={{ width: "300px", margin: "0 auto" }}>
            <Spinner />
          </div>
        ) : //redirectUrl
        this.props.topUped ? (
          <Procced topUped={this.props.topUped} />
        ) : this.props.error ? (
          <p
            style={{
              width: "80%",
              margin: "2% auto",
              textAlign: "center",
              fontWeight: "600",
              color: "#32baa5",
              fontSize: "1.1rem",
            }}
          >
            {this.props.error}
          </p>
        ) : (
          <Fragment>
            <TopUPOption topUp={this.props.onTopUpToken} />
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    toping: state.TopUp.toping,
    topUped: state.TopUp.topUped,
    error: state.TopUp.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTopUpToken: (amount) => {
      dispatch(actionCreator.topUpToken(amount));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TopUp);
